import { theme } from './constants';
import { StackNavigator } from './navigation/StackNavigator';
import toast, { Toaster } from 'react-hot-toast';
function App() {
  return (
    <div style={{ height: '100vh' }}>
      <Toaster
        position="top-center"
        toastOptions={{
          duration: 4000,
          style: {
            background: '#fff',
            color: theme.colors.mainColor,
            border: '1px solid #005840'
          },
        }}
      />
      <StackNavigator />
    </div>
  );
}

export default App;
